import { useContext } from "react";
import { MachineCenterLogsContext } from "contexts/MachineCenterLogsContext/MachineCenterLogsContext";

const useMachineCenterLogs = () => {
    const { triggerMachineCenterLogs } = useContext(MachineCenterLogsContext);

    return { triggerMachineCenterLogs };
};

export default useMachineCenterLogs;
